import React, { FC } from 'react';

const TableHeadItem: FC<{ heading: string }> = ({ heading }) => {
  return <td title={heading}>{heading}</td>;
};

export default TableHeadItem;
